import { render } from "./FlakeStatCards.vue?vue&type=template&id=34d0dafe&ts=true"
import script from "./FlakeStatCards.vue?vue&type=script&lang=ts"
export * from "./FlakeStatCards.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__